import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {PaymentView} from "../views/payment";

export class PaymentFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new PaymentView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/payment`;
    }

}
